import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function P() {
    const { useLang } = useGlobal();
    const { t } = useLang('powerindependence');

    return (
        <div id="power-independence-P" className={`power-independence-P ${css['power-independence-P']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secP_title')}</p>
                </div>
            </div>
            <div className="card">
                <div className="img-box">
                    <EFPicture
                        src={'/responsive/picture/power-independence/15.jpg'}
                        srcPad={'/responsive/picture/power-independence/15_768.jpg'}
                        srcMobile={'/responsive/picture/power-independence/15_768.jpg'}
                        alt={t('secP_title')}
                    />
                </div>
                <p className="img-text">{t('secP_text')}</p>
            </div>
        </div>
    );
}
